import { useExchangeRatesContext } from "./ExchangeRatesContext";

/**
 Hook per recuperare i tassi di cambio (wrapper per il Context)
 Usa ExchangeRatesContext per evitare fetch multipli
 I tassi sono caricati una volta all'avvio in _app.tsx
 Cache con TTL di 1 ora
 Condivisi tra tutti i componenti
  Non fa fetch se cache è valida
 * @deprecated Usa direttamente useExchangeRatesContext se hai bisogno di refreshRates
 */
export const useExchangeRates = () => {
    const { rates, loading, error } = useExchangeRatesContext();
    return { rates, loading, error };
};
